/**
 * Fee submodule rows are loaded from the platform DB catalog (`platform_submodules`)
 * via role / user module-access API responses. Keep these helpers as identity
 * passthroughs for callers that still merge subscription payloads.
 */

export function mergeFeesSubmodulesIntoRoleModules<T>(modules: T[]): T[] {
  return modules;
}

export function mergeFeesSubmodulesIntoUserModuleAccess<T>(modules: T[]): T[] {
  return modules;
}

export function mergeFeesSubmodulesIntoTenantModules<T>(modules: T[]): T[] {
  return modules;
}

export function isFeesModuleCode(moduleCode: string): boolean {
  const code = moduleCode.trim().toLowerCase();
  return code === 'fees' || code === 'fee' || code.endsWith('_fees') || code.endsWith('_fee');
}
